import {
  CdkVirtualScrollViewport,
  ScrollingModule,
} from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { UserTimelinesModal } from '@wilson/interfaces';
import { TimelineContentLoaderComponent } from '@wilson/shift-timeline/core';
import { ShiftAssignmentModalState } from '@wilson/shift-timeline/state';
import { Observable, Subscription, combineLatest, map } from 'rxjs';
import { TimelineModalHeaderComponent } from '../timeline-modal-header/timeline-modal-header.component';
import { TimelineModalLoaderComponent } from '../timeline-modal-loader/timeline-modal-loader.component';
import { TimelineModalRowComponent } from '../timeline-modal-row/timeline-modal-row.component';

@Component({
  selector: 'wilson-modal-timeline',
  templateUrl: './modal-timeline.component.html',
  styleUrls: ['./modal-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ScrollingModule,
    TimelineModalHeaderComponent,
    TimelineModalLoaderComponent,
    TimelineContentLoaderComponent,
    TimelineModalRowComponent,
  ],
})
export class TimelineModalComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private readonly store = inject(Store);

  @Input() isShiftAssignment = false;
  public stickyHasShadow = false;
  public mouseOverRowIndex: null | number = null;
  public isFetchedShiftAssignmentSuccessful$!: Observable<boolean>;
  public scrollToPx$!: Observable<number>;

  @Input()
  userTimelinesInfo!: UserTimelinesModal[] | null;

  @ViewChildren('cdkVirtualScroll')
  cdkVirtualScroll!: QueryList<CdkVirtualScrollViewport>;
  @ViewChildren('timeline') timeline!: QueryList<ElementRef<HTMLDivElement>>;

  isFiltering$ = this.store.select(ShiftAssignmentModalState.showFilterLoading);

  private subscription = new Subscription();

  onScroll(event: Event & { target: { scrollTop?: number } }): void {
    this.stickyHasShadow = event.target.scrollTop !== 0;
  }
  async ngOnInit(): Promise<void> {
    this.isFetchedShiftAssignmentSuccessful$ = this.store.select(
      ShiftAssignmentModalState.isFetchedShiftAssignmentSuccessful,
    );
    this.scrollToPx$ = this.store.select(ShiftAssignmentModalState.scrollToPx);
  }

  ngAfterViewInit(): void {
    this.subscription = combineLatest([
      this.cdkVirtualScroll.changes.pipe(
        map(() => this.cdkVirtualScroll.get(0)),
      ),
      this.scrollToPx$,
    ]).subscribe(([viewPort, scrollLeft]) => {
      if (viewPort?.getElementRef()?.nativeElement) {
        viewPort.scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: 'instant',
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
